import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateBlankProjectComponent } from './create-blank-project/create-blank-project.component';
import { CloneExistingProjectComponent } from './clone-existing-project/clone-existing-project.component';

@Component({
  selector: 'app-project-form-panel',
  templateUrl: './project-form-panel.component.html',
  styleUrls: ['./project-form-panel.component.scss'],
  standalone: true,
  imports: [CommonModule, CreateBlankProjectComponent, CloneExistingProjectComponent]
})
export class ProjectFormPanelComponent implements OnInit, OnChanges {
  @Input() existingProjectCount: number = 0;
  @Input() isSelfServiceUser: boolean = false;
  @Output() closePanel = new EventEmitter<void>();
  @Output() projectCreated = new EventEmitter<any>();

  @ViewChild(CreateBlankProjectComponent) blankProjectForm?: CreateBlankProjectComponent;
  @ViewChild(CloneExistingProjectComponent) cloneProjectForm?: CloneExistingProjectComponent;

  isVisible: boolean = false;
  activeTab: 'blank' | 'clone' = 'blank';

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(_changes: SimpleChanges): void {
    if (!this.canShowCloneTab && this.activeTab === 'clone') {
      this.activeTab = 'blank';
    }
  }

  get canShowCloneTab(): boolean {
    return !this.isSelfServiceUser && this.existingProjectCount > 0;
  }

  open(tab: 'blank' | 'clone' = 'blank'): void {
    this.activeTab = tab === 'clone' && this.canShowCloneTab ? 'clone' : 'blank';
    this.isVisible = true;
  }

  close(): void {
    this.isVisible = false;
    this.closePanel.emit();
  }

  changeTab(tab: 'blank' | 'clone'): void {
    if (tab === 'clone' && !this.canShowCloneTab) {
      return;
    }
    this.activeTab = tab;
  }

  onProjectCreated(projectData: any): void {
    this.projectCreated.emit(projectData);
    this.close();
  }

  onProjectCloned(cloneData: any): void {
    this.projectCreated.emit(cloneData);
    this.close();
  }

  onCancel(): void {
    this.close();
  }

  get activeForm(): CreateBlankProjectComponent | CloneExistingProjectComponent | undefined {
    return this.activeTab === 'blank' ? this.blankProjectForm : this.cloneProjectForm;
  }

  canSubmit(): boolean {
    return !!this.activeForm?.canSubmit();
  }

  submit(): void {
    this.activeForm?.submit();
  }
}
